import { useTranslation } from 'next-i18next/pages';
import { useEffect } from 'react';
import { create } from 'zustand';

import { useToast } from '../toaster/ToastProvider';

type ErrorStoreType = {
  isThrottleToastShown: boolean;
  showThrottleToast: () => void;
  removeThrottleToast: () => void;
};

export const useThrottleToastState = create<ErrorStoreType>()(set => ({
  isThrottleToastShown: false,
  showThrottleToast: () =>
    set({
      isThrottleToastShown: true,
    }),
  removeThrottleToast: () =>
    set({
      isThrottleToastShown: false,
    }),
}));

export const useThrottleToast = () => {
  const toast = useToast();
  const { t } = useTranslation();
  const isThrottleToastShown = useThrottleToastState(state => state?.isThrottleToastShown);
  const removeThrottleToast = useThrottleToastState(state => state?.removeThrottleToast);

  useEffect(() => {
    if (isThrottleToastShown) {
      toast?.error(t('common:errors.tooManyRequests'));
      removeThrottleToast();
    }
  }, [isThrottleToastShown, removeThrottleToast, t, toast]);
};
